// extracted by mini-css-extract-plugin
export default {"reviewPhotoGallery":"Vq-z","imageAndVideoCount":"Wq-z","imageAndVideoContainer":"Xq-z","viewAllReviews":"Yq-z"};